// extracted by mini-css-extract-plugin
export var btnLogin = "Header-module--btnLogin--68c91";
export var btnSignUp = "Header-module--btnSignUp--609d2";
export var btnWrapper = "Header-module--btnWrapper--b6c3f";
export var content = "Header-module--content--fd25c";
export var header = "Header-module--header--357cc";
export var logo = "Header-module--logo--edb3a";
export var notification = "Header-module--notification--0c5f9";
export var notificationIsShown = "Header-module--notificationIsShown--cd117";
export var root = "Header-module--root--6d142";
export var transparentBg = "Header-module--transparentBg--6bfa1";
export var wrapper = "Header-module--wrapper--ed1d5";